import type { AxiosInstance } from 'axios'

export const uploadFile = (api: AxiosInstance) => (form: any) =>
  api.post('/v1.0/files', form)
